<!-- Minimal mode for matter page -->
<div *ngIf="minimalMode">
  <div class="text-center" *ngIf="searching">
    <i class="fas fa-spinner fa-pulse fa-3x"></i>
  </div>
  <div *ngIf="!searching">
    <div class="row mt-3">
      <div class="col-md-10 ml-md-auto mr-md-auto">
        <div class="row">
          <div class="col-md-8">
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="search()">
              <i class="fas fa-redo fa-fw"></i>
            </button>
          </div>
          <div class="col-md-4 text-center ml-md-auto">
            <pagination
              class="pagination-sm"
              (pageChanged)="search($event)"
              [boundaryLinks]="true"
              [totalItems]="count"
              [maxSize]="5"
              name='search_params_page'
              ngDefaultControl
              [(ngModel)]="searchParams.page"
              [itemsPerPage]="searchParams.per_page"
              previousText="&lsaquo;"
              nextText="&rsaquo;"
              firstText="&laquo;"
              lastText="&raquo;"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-2 offset-1"><h5>Id</h5></div>
      <div class="col-2"><h5>Created</h5></div>
      <div class="col-2"><h5>Status</h5></div>
      <div class="col-1 text-center"><h5>Checks</h5></div>
      <div class="col-1 text-center"><h5>Docs</h5></div>
      <div class="col-1 text-center"><h5>Envel.</h5></div>
      <div class="col-1 text-center"><h5>Labels</h5></div>
    </div>
    <div class="row py-3 odd-color-mute" *ngFor="let outgoing_job of outgoingJobs" style="font-size: 85%">
      <div class="col-2 offset-1">
        <a [ngClass]="{ 'text-danger': outgoing_job.fileshare_download_missing }" [href]="'/outgoing_jobs/' + outgoing_job.id" target="_blank">{{ outgoing_job.id }}</a>
      </div>
      <div class="col-2" [tooltip]="outgoing_job.created_at_time" [title]="outgoing_job.created_at_time">{{ outgoing_job.created_at_date }}</div>
      <div class="col-2">
        <app-outgoing-job-status [outgoingJob]="outgoing_job"></app-outgoing-job-status>
      </div>
      <div class="col-1 text-center">{{ outgoing_job.outgoing_checks_size }}</div>
      <div class="col-1 text-center">{{ outgoing_job.outgoing_documents_size }}</div>
      <div class="col-1 text-center">{{ outgoing_job.outgoing_envelopes_size }}</div>
      <div class="col-1 text-center">{{ outgoing_job.outgoing_labels_size }}</div>
    </div>
  </div>
</div>
<!-- Outgoing jobs index page -->
<div *ngIf="!minimalMode">
  <div id="content-section">
    <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '420px' : '360px' }">
      <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '400px' : '340px' }" style="position: fixed; right: 20px">
        <div class="sticky-top">
          <small class="bg-white">
            <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
              <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
            </a>
          </small>
        </div>
        <div class="text-center pagination-small-margin pagination-center">
          <pagination name='search_params_page2' ngDefaultControl [boundaryLinks]="true" [totalItems]="count" (pageChanged)="search($event)" class="pagination-sm" [itemsPerPage]="searchParams.per_page" [maxSize]="3" previousText="&lsaquo;" nextText="&rsaquo;" [(ngModel)]="searchParams.page" firstText="&laquo;" lastText="&raquo;"></pagination>
        </div>
        <div class="text-center pt-1">
          <app-pagination-count
            [count]="count"
            singularName="Outgoing Job"
            pluralName="Outgoing Jobs"
          ></app-pagination-count>
        </div>
        <hr class="my-1" />
        <div class="clearfix"></div>
        <div class="sticky-top bg-white">
          <h5 class="pt-2">
            <div class="pull-right float-right">
              <app-clear-search-btn [searching]="searching" (onClick)="clearSearch()"></app-clear-search-btn>
            </div>
            <span>
              Search&nbsp;&nbsp;
              <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search() : ''"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
            </span>
          </h5>
          <hr class="my-1" />
        </div>
        <div class="row">
          <div class="col-md-12" id="search-form" style="border-bottom: 1px solid #ccc">
            <div class="form-group mt-3">
              <label>Matter Name/Number</label>
              <app-matter-search #matterSearch [matterId]="searchParams.matter_id" [small_input]="true" (clearMatter)="searchParams.matter_id = undefined" (matter_id)="searchParams.matter_id = $event"></app-matter-search>
            </div>
            <div class="form-group">
              <label>For</label>
              <select class="form-control form-control-sm" name="created_by" ngDefaultControl [(ngModel)]="searchParams.created_by">
                <option value=""></option>
                <option *ngFor="let intranetUser of searchOptions.intranet_users" [value]="intranetUser.value">
                  {{ intranetUser.label }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Status</label>
              <select class="form-control form-control-sm" name="status" ngDefaultControl [(ngModel)]="searchParams.status">
                <option value=""></option>
                <option *ngFor="let status of searchOptions.statuses" [value]="status.value">
                  {{ status.label }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Document Type</label>
              <select class="form-control form-control-sm" name="document_type_name" ngDefaultControl [(ngModel)]="searchParams.document_type_name">
                <option value=""></option>
                <option *ngFor="let documentTypeName of searchOptions.document_type_names" [value]="documentTypeName">
                  {{ documentTypeName }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Only With Outgoing Type</label>
              <select class="form-control form-control-sm" name="outgoing_type" ngDefaultControl [(ngModel)]="searchParams.outgoing_type">
                <option value=""></option>
                <option *ngFor="let outgoingTypeName of searchOptions.outgoing_types" [value]="outgoingTypeName">
                  {{ outgoingTypeName }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Single Job ID</label>
              <input type="text" class="form-control" name="job_id" ngDefaultControl [(ngModel)]="searchParams.job_id" (keyup.enter)="search()" />
            </div>
            <div class="form-row">
              <div class="col-6">
                <label>Date From</label>
                <app-datetime-picker [dateStrSeparator]="'/'" [showTimePicker]="false" (ngbResult)="searchParams.date_from_struct = $event"></app-datetime-picker>
              </div>
              <div class="col-6">
                <label>Date To</label>
                <app-datetime-picker [dateStrSeparator]="'/'" [showTimePicker]="false" (ngbResult)="searchParams.date_to_struct = $event"></app-datetime-picker>
              </div>
            </div>
            <div class="form-group mt-2">
              <div class="custom-control custom-checkbox" (click)="searchParams.hide_finished = !searchParams.hide_finished; searchParams.hide_finished ? searchParams.hide_finished : (searchParams.hide_finished = undefined)">
                <input type="checkbox" class="custom-control-input" name="hide_finished" [checked]="searchParams.hide_finished" />
                <label class="custom-control-label">Hide Finished Jobs</label>
              </div>
            </div>
            <div class="form-group">
              <button (click)="searchParams.page = 1; search()" class="btn btn-primary btn-sm" style="width: 100%" type="button" [disabled]="searching">
                Search
                <span *ngIf="searching">
                  &nbsp;
                  <i class="fas fa-spinner fa-fw fa-pulse"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
        <div class="container-shadow px-3 pb-4">
          <h2 class="pt-4 text-center">Outgoing Jobs</h2>
          <div class="btn-group btn-group-sm mt-2">
            <button *ngIf="searchOptions.lock_file_exists" type="button" class="btn btn-sm btn-warning" [disabled]="deletingLockFile || processingAction" (click)="deleteLockFile()">
              <i class="fas fa-unlock"></i>&nbsp;{{ deletingLockFile ? 'Deleting' : 'Delete' }} Lock File
              <span *ngIf="deletingLockFile">
                &nbsp;
                <i class="fas fa-spinner fa-fw fa-pulse"></i>
              </span>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-success"
              *ngIf="outgoingJobs && outgoingJobs.length > 0 && searchParams && searchParams.status == 'ready' && (searchParams.document_type_name == 'Invoice' || searchParams.outgoing_type == 'Check')"
              [disabled]="finishingOutgoingJobs || processingAction"
              (click)="finishOutgoingJobs()"
            >
              <i class="fas fa-print" [ngClass]="{ 'fa-spin': finishingOutgoingJobs }"></i>&nbsp;{{ finishingOutgoingJobs ? 'Finishing' : 'Finish' }}&nbsp;({{ outgoingJobs.length }} job{{ outgoingJobs.length == 1 ? '' : 's' }})
            </button>
            <button type="button" class="btn btn-sm btn-primary" *ngIf="outgoingJobs && outgoingJobs.length > 0" [disabled]="printingOutgoingJobs || processingAction" (click)="printOutgoingJobs()">
              <i class="fas fa-print" [ngClass]="{ 'fa-spin': printingOutgoingJobs }"></i>&nbsp;{{ printingOutgoingJobs ? 'Printing' : 'Print' }}&nbsp;({{ outgoingJobs.length }} job{{ outgoingJobs.length == 1 ? '' : 's' }})
            </button>
            <button type="button" class="btn btn-sm btn-primary" *ngIf="outgoingJobs && outgoingJobs.length > 0" [disabled]="resubmittingOutgoingJobs || processingAction" (click)="resubmitOutgoingJobs()">
              <i class="fas fa-undo spin-reverse" [ngClass]="{ 'fa-spin': resubmittingOutgoingJobs }"></i>&nbsp;{{ resubmittingOutgoingJobs ? 'Resubmitting' : 'Resubmit' }}&nbsp;({{ outgoingJobs.length }} job{{ outgoingJobs.length == 1 ? '' : 's' }})
            </button>
          </div>
          <div class="py-1"></div>
          <div class="table-responsive-md">
            <table class="table table-striped" *ngIf="count > 0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Date</th>
                  <th>Description</th>
                  <th>Status</th>
                  <th>Processor</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let outgoingJob of outgoingJobs">
                  <td>
                    <a [ngClass]="{ 'text-danger': outgoingJob.priority || outgoingJob.fileshare_download_missing }" [routerLink]="'/outgoing_jobs/' + outgoingJob.id">{{ outgoingJob.id }}</a>
                  </td>
                  <td>{{ outgoingJob.created_at_str }}</td>
                  <td>
                    <span *ngIf="outgoingJob.created_by_user_name">
                      <a [routerLink]="'/contacts/' + outgoingJob.created_by_user_person_id">
                        {{ outgoingJob.created_by_user_name }}
                      </a>
                      <br />
                    </span>
                    <span *ngIf="outgoingJob.matter_id && outgoingJob.matter_number">
                      <a class="font-weight-normal" [routerLink]="'/matters/' + outgoingJob.matter_id">{{ outgoingJob.matter_number }}</a>
                      &nbsp;-&nbsp;{{ outgoingJob.matter_name }}
                    </span>
                    <span class="text-warning" *ngIf="!outgoingJob.matter_id || !outgoingJob.matter_number"> Matter {{ !outgoingJob.matter_id ? 'not specified' : 'not found' }} </span>
                    <br />
                    <span *ngIf="outgoingJob.priority">
                      <app-badge badgeType="danger">
                        Priority
                        <i class="fas fa-exclamation-circle"></i>
                      </app-badge>
                      &nbsp;
                    </span>
                    <span *ngIf="outgoingJob.outgoing_documents_size > 0">
                      <app-pagination-count
                        [count]="outgoingJob.outgoing_documents_size"
                        singularName="document"
                        pluralName="documents"
                      ></app-pagination-count>
                      &nbsp;
                    </span>
                    <span *ngIf="outgoingJob.outgoing_envelopes_size > 0">
                      <app-pagination-count
                        [count]="outgoingJob.outgoing_envelopes_size"
                        singularName="envelope"
                        pluralName="envelopes"
                      ></app-pagination-count>
                      &nbsp;
                    </span>
                    <span *ngIf="outgoingJob.outgoing_checks_size > 0">
                      <app-pagination-count
                        [count]="outgoingJob.outgoing_checks_size"
                        singularName="check"
                        pluralName="checks"
                      ></app-pagination-count>
                      &nbsp;
                    </span>
                    <span *ngIf="outgoingJob.outgoing_labels_size > 0">
                      <app-pagination-count
                        [count]="outgoingJob.outgoing_labels_size"
                        singularName="label"
                        pluralName="labels"
                      ></app-pagination-count>
                      &nbsp;
                    </span>
                    <span *ngIf="outgoingJob.outgoing_document_faxes_size > 0">
                      <app-pagination-count
                        [count]="outgoingJob.outgoing_document_faxes_size"
                        singularName="fax"
                        pluralName="faxes"
                      ></app-pagination-count>
                      &nbsp;
                    </span>
                  </td>
                  <td>
                    <app-outgoing-job-status [outgoingJob]="outgoingJob"></app-outgoing-job-status>
                    <div class="py-1"></div>
                    <button type="button" *ngIf="outgoingJob.status == 'error' || outgoingJob.status == 'stalled'" [disabled]="outgoingJob.continuing || processingAction" (click)="continueOutgoingJob(outgoingJob)" class="btn btn-sm btn-success w-100">
                      <i class="fas fa-redo" [ngClass]="{ 'fa-spin': outgoingJob.continuing }"></i>&nbsp;{{ outgoingJob.continuing ? 'Continuing' : 'Continue' }}
                    </button>
                    <div *ngIf="outgoingJob && outgoingJob.last_errors_count && outgoingJob.last_errors_count > 0" class="text-danger">{{ outgoingJob.last_errors_count }} {{ outgoingJob.last_errors_count == 1 ? 'error' : 'errors' }}</div>
                  </td>
                  <td>
                    <span *ngIf="outgoingJob.checked_out">
                      <a [routerLink]="'/contacts/' + outgoingJob.checked_out_by_contact_id">{{ outgoingJob.checked_out_by_user_name }}</a>
                      <br />
                    </span>
                    <div class="btn-group btn-group-sm mt-2" *ngIf="!loading && outgoingJob">
                      <button
                        type="button"
                        *ngIf="(canProcessAllOutgoingJobs || currentUserId == outgoingJob.created_by) && outgoingJob.status == 'ready' && outgoingJob.checked_out"
                        [disabled]="outgoingJob.finishing || processingAction"
                        (click)="finishOutgoingJob(outgoingJob)"
                        class="btn btn-sm btn-success"
                      >
                        <i class="fas fa-print"></i>&nbsp;{{ outgoingJob.finishing ? 'Completing' : 'Finish' }}
                        <span *ngIf="outgoingJob.finishing">
                          &nbsp;
                          <i class="fas fa-spinner fa-fw fa-pulse"></i>
                        </span>
                      </button>
                      <button
                        type="button"
                        *ngIf="(canProcessAllOutgoingJobs || currentUserId == outgoingJob.created_by) && outgoingJob.status == 'ready' && outgoingJob.checked_out"
                        [disabled]="outgoingJob.releasing || processingAction"
                        (click)="releaseOutgoingJob(outgoingJob)"
                        class="btn btn-sm btn-primary"
                        title="Release outgoing job"
                      >
                        <i class="fas fa-user-slash"></i>&nbsp;{{ outgoingJob.releasing ? 'Releasing' : 'Release' }}
                        <span *ngIf="outgoingJob.releasing">
                          &nbsp;
                          <i class="fas fa-spinner fa-fw fa-pulse"></i>
                        </span>
                      </button>
                      <button type="button" *ngIf="outgoingJob.status == 'ready' && !outgoingJob.checked_out" [disabled]="outgoingJob.taking || processingAction" (click)="takeOutgoingJob(outgoingJob)" class="btn btn-sm btn-primary" title="Take outgoing job">
                        <i class="fas fa-user-check"></i>&nbsp;{{ outgoingJob.taking ? 'Assigning' : 'Take' }}
                        <span *ngIf="outgoingJob.taking">
                          &nbsp;
                          <i class="fas fa-spinner fa-fw fa-pulse"></i>
                        </span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>
</div>
